var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisabledCheckbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_64_2896",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 1H3H1V3V21V23H3H21H23V21V10C23 9.44772 22.5523 9 22 9C21.4477 9 21 9.44772 21 10V21H3V3H21V4C21 4.55228 21.4477 5 22 5C22.5523 5 23 4.55228 23 4V3V1H21ZM20.707 7.707L11.707 16.707C11.512 16.902 11.256 17 11 17C10.744 17 10.488 16.902 10.293 16.707L6.293 12.707C5.902 12.316 5.902 11.684 6.293 11.293C6.684 10.902 7.316 10.902 7.707 11.293L11 14.586L19.293 6.293C19.684 5.902 20.316 5.902 20.707 6.293C21.098 6.684 21.098 7.316 20.707 7.707Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_64_2896)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7068 16.7072L20.7068 7.70725C21.0978 7.31625 21.0978 6.68425 20.7068 6.29325C20.3158 5.90225 19.6838 5.90225 19.2928 6.29325L10.9998 14.5863L7.70676 11.2933C7.31576 10.9023 6.68376 10.9023 6.29276 11.2933C5.90176 11.6842 5.90176 12.3163 6.29276 12.7073L10.2928 16.7072C10.4878 16.9022 10.7438 17.0002 10.9998 17.0002C11.2558 17.0002 11.5118 16.9022 11.7068 16.7072Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledCheckbox);
export default __webpack_public_path__ + "static/media/disabledCheckbox.5e36a1301b217a5059d92ecb96b9bbd7.svg";
export { ForwardRef as ReactComponent };